//@ts-nocheck
/* 
 *  This file app.component.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, NavigationCancel, NavigationError, RouterOutlet } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { AuthService } from './global/services/auth-service';
import { SharedService } from './global/services/shared.service';
import { NewRelicRouterTrackerService } from './global/services/newrelic-handler/newrelic-router-tracker.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterOutlet, ConfirmDialogModule]
})
export class AppComponent implements OnInit, AfterViewInit {
  flashLoader = "/assets/images/init-loader-1.svg";
  flashLoaderGT = "assets/images/dynamic_images/loader-2.svg";
  title = 'app';
  public isShowingRouteLoadIndicator: boolean;
  isPageLoading: boolean;
  isTimeOut: boolean;
  isClientConfig = true;

  constructor(
    public router: Router,
    private _auth: AuthService,
    public _shared: SharedService,
    private titleService: Title,
    private newRelicRouterTracker: NewRelicRouterTrackerService
  ) {
    const isGTInstance = this._shared._config.configData ? this._shared._config.configData.isDeployOnGT && this._shared._config.configData.isDeployOnGT : true;
    localStorage.setItem('clientConfig', isGTInstance);
    if (isGTInstance) {
      this.isClientConfig = JSON.parse(localStorage.getItem('clientConfig'));
    } else {
      this.isClientConfig = false
    }
  }

  ngOnInit() {
    const favicon = document.getElementById("favicon");
    favicon.setAttribute(
      "href",
      this._shared.companyDetails.favicon
    );
    this.setTitle();
   // this._shared.getAppVersion();
    this.router.events.subscribe(event => {
      this.navigationInterceptor(event);
    });
    this.getClientDomainValues();

        // Start New Relic router tracking if available
    // (New Relic is already initialized in main.ts)
    this.startNewRelicRouterTracking();
  }

  ngAfterViewInit() {
    this._auth.refreshTokenOnWindowReload();
    this.listenForLogout();
  }

  listenForLogout() {
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        const token = localStorage.getItem('authlogin');
        if (!token) {
          if (event.key !== 'upcomingLinkVerified') {
            this.router.navigate(['/']);
          }
        }
      }
    }, false);
  }

  navigationInterceptor(event): void {
    // save the redirection url
    if (!localStorage.getItem('authlogin')) {
      if (event instanceof NavigationCancel) {
        localStorage.setItem('NAVIGATIONKEY', event.url);
      }
    }
    if (event instanceof NavigationEnd || event instanceof NavigationCancel ||
      event instanceof NavigationError) {
      this.isPageLoading = false;
    }
  }

  getClientDomainValues() {
    const hd = localStorage.getItem('hashDomain');
    if (hd) {
      this._shared.getComapanyDetails(hd);
    } else {
      this._shared.getDefaultCompDetails();
    }

  }
  public setTitle() {
    this.titleService.setTitle(this._shared.companyDetails.title);
  }

    /**
   * Start New Relic Router Tracking
   * Note: New Relic agent is already initialized in main.ts for early load capture
   */
    private startNewRelicRouterTracking(): void {
      try {
        // Start router tracking for SPA navigation
        this.newRelicRouterTracker.startTracking();
      } catch (error) {
        // Silently fail if New Relic is not available
        console.debug('New Relic router tracking not started:', error);
      }
    }
}